import { useEffect, useState } from "react";
import { Menu, X, Instagram } from "lucide-react";

const links = [
    { label: "Mix & Mastering", href: "#services" },
    { label: "Records", href: "#portfolio" },
    { label: "About", href: "#about" },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[#F4F3EF]/85 backdrop-blur-xl border-b border-black/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <nav className="max-w-[1440px] mx-auto px-6 lg:px-12 h-16 lg:h-20 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-brand"
                    className="group inline-flex flex-col leading-[1] text-ink"
                    aria-label="Denis Catapano — Mix & Master"
                >
                    <span className="font-serif-display text-[22px] lg:text-[26px] leading-none tracking-[-0.01em] text-ink transition-transform duration-500 group-hover:-translate-y-[1px]">
                        Denis Catapano
                    </span>
                    <span className="mt-1.5 font-mono text-[9px] lg:text-[10px] tracking-[0.32em] uppercase text-quiet">
                        Mix &middot; Master
                    </span>
                </a>

                <ul className="hidden lg:flex items-center gap-7 xl:gap-9">
                    {links.map((l) => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                data-testid={`nav-link-${slug(l.label)}`}
                                className="editorial-link font-mono text-[11px] tracking-[0.22em] uppercase"
                            >
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>

                <div className="flex items-center gap-3">
                    <button
                        data-testid="nav-mobile-toggle"
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden w-10 h-10 inline-flex items-center justify-center border border-black/20"
                        aria-label="Toggle menu"
                    >
                        {open ? <X size={18} /> : <Menu size={18} />}
                    </button>
                </div>
            </nav>

            {open && (
                <div
                    data-testid="nav-mobile-panel"
                    className="lg:hidden bg-bone border-t border-black/10"
                >
                    <ul className="px-6 py-8 flex flex-col gap-6">
                        {links.map((l) => (
                            <li key={l.href}>
                                <a
                                    href={l.href}
                                    onClick={() => setOpen(false)}
                                    data-testid={`nav-mobile-link-${slug(l.label)}`}
                                    className="font-serif-display text-3xl tracking-tight text-ink"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a
                                href="#contact"
                                onClick={() => setOpen(false)}
                                data-testid="nav-mobile-cta"
                                className="inline-flex items-center gap-2 mt-2 px-5 py-3 bg-ink text-bone font-mono text-xs tracking-[0.22em] uppercase"
                            >
                                Get a Quote →
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://instagram.com/"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="nav-mobile-instagram"
                                className="inline-flex items-center gap-2 text-ink font-mono text-xs uppercase tracking-[0.22em]"
                            >
                                <Instagram size={16} /> Instagram
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </header>
    );
};

export default Navbar;
